export const en = {
    "ADD": "Add",
    "ADDRESS": "Address",
    "ADMIN": "Administration",
    "APPLICATION": "Application",
    "CANCEL": "Cancel",
    "CHANGE LANGUAGE": "Change language",
    "CLOSE": "Close",
    "CONFIRM": "Are you sure?",
    "CONFIRM WARNING": "This action cannot be undone",
    "CONTACT": "Contact",
    "CREATE": "Create",
    "CURRENT": "Current",
    "DATA": "Data",
    "DATE": "Date",
    "DELETE": "Delete",
    "DELETE CONFIRM": "Are you sure you want to delete this item",
    "DELETE CONFIRM MULTIPLE": "Are you sure you want to delete these items",
    "DETAIL": "Detail",
    "DETAILS": "Details",
    "EDIT": "Edit",
    "EMAIL": "E-mail",
    "EMAIL ADDRESS": "E-mail address",
    "EMAIL ERROR": "This is not a valid email address",
    "ERROR": "Error",
    "FIELD":"Field",
    "FIELD REQUIRED":"This field is required",
    "FORM INVALID": "The formulier can not be submitted yet. Please fill in the required fields",
    "FORM SUCCESS": "The data have been stored",
    "LOGIN": "Login",
    "LOGIN ERROR": "Wrong credentials",
    "LOGIN EXPIRED": "Your authorization has expired. Please login again",
    "LOGOUT": "Log out",
    "NAME": "Name",
    "PASSWORD": "Password",
    "PASSWORD REQUIRED": "Er is geen wachtwoord ingevoerd",
    "PASSWORD ERROR": "Password is required",
    "PASSWORD MATCH ERROR": "The passwords don't match",
    "SUBMIT": "Submit",


    "HOME": "Home",
    "NAME ERROR": "This is not a valid name",
    "NETWORK ERROR": "There is no internet connection",
    "REMEMBER": "Remember",
    "REMARKS": "Remarks",
    "SECTION": "Section",
    "SECTIONS": "Sections",
    "REQUIRED": "Required",
    "SAVE": "Save",
    "USER": "User",
    "USERS": "Users"
};
